import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  searchResult: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      pageType: 'resultado-de-busca',
      pageName: '/webmotors/comprar/resultado-antigo',
      pageNameTier2: 'resultado',
    },
  },
}
